<template>
  <div>
    <home-header />
    <div class="content page-width">
      <personal-center />
      <div class="margin-top-30"></div>
      <a-spin :spinning="newsSpinning">
        <a-table :dataSource="dataSource" :columns="columns" bordered>
          <template slot="path" slot-scope="text, record">
            <a target="_blank" @click="openForm(text)">填写问卷</a>
          </template>
        </a-table>
      </a-spin>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import Foot from "@/common/components/Foot";
import PersonalCenter from "@/common/components/PersonalCenter";


export default {
  name: "tduckForm",
  components: {
    HomeHeader,
    Foot,
    PersonalCenter
  },
  data: function() {
    return {
      arrs: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      newsSpinning: true,
      columns: [
        {
          title: '问卷名称',
          dataIndex: 'textName',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '开始时间',
          dataIndex: 'settings.writeInterviewDateTimeRange[0]',
          align: 'center',
          width: 200,
        },
        {
          title: '截止时间',
          dataIndex: 'settings.writeInterviewDateTimeRange[1]',
          align: 'center',
          width: 200,
        },
        {
          title: '操作',
          dataIndex: 'path',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'path' },
        }
      ],
      dataSource: []
    };
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    getDetailInfo() {
      let userinfo = JSON.parse(localStorage.getItem('userInfo'))
      this.axios
          .get(
              `/tduckForm/list?pageNo=${this.pageNo}&pageSize=${this.pageSize}&eduCode=${userinfo.eduCode}`
          )
          .then(res => {
            console.log(res)
            if (res.success) {
              this.total = res.result.total;
              this.dataSource = res.result.records;
            }
          })
          .finally(() => {
            this.newsSpinning = false;
          });
    },
    handleGetDataSucc(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.arrs = data.course;
      }
    },
    onChange(index) {
      this.newsSpinning = true;
      this.pageNo = index;
      this.getDetailInfo();
    },
    openForm(path){
      window.open(path)
    }
  },
  mounted() {
    // this.getDetailInfo()
  }
};

</script>



<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;

    .localtion {
      line-height: 30px;
      border-bottom: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.content-left {
  background: #f7f6f6;
}
</style>
<style>
.pagination {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/tduckForm/index.vue